import { render, staticRenderFns } from "./FeedLimit.vue?vue&type=template&id=2d8e3353&scoped=true&"
import script from "./FeedLimit.vue?vue&type=script&lang=ts&"
export * from "./FeedLimit.vue?vue&type=script&lang=ts&"
import style0 from "./FeedLimit.vue?vue&type=style&index=0&id=2d8e3353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e3353",
  null
  
)

export default component.exports